import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { RequiredValidation } from 'components/UI/RequiredValidation/RequiredValidation';

export default function Paragraph({ index, item, handleSettingsClick, isFormBuilder }) {
  const name = `form_data.${index}.description`;
  const {
    watch,
    control,
    formState: { errors },
  } = useFormContext();
  const description = watch(name);

  return (
    <div className="w-100">
      {description ? (
        <p className="w-100 mb-0" style={{ textAlign: item?.alignment, whiteSpace: 'pre-wrap' }}>
          {description}
        </p>
      ) : (
        <p className="w-100 mb-0 cursor-pointer" onClick={() => handleSettingsClick(item)}>
          Click to add description
        </p>
      )}
      {isFormBuilder && (
        <>
          <Controller
            name={name}
            control={control}
            rules={{ required: true }}
            render={({ field }) => <input ref={field.ref} type="hidden" value={field.value || ''} onChange={field.onChange} />}
          />
          <RequiredValidation field={name} errors={errors} message="Paragraph content not added" />
        </>
      )}
    </div>
  );
}
